<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'TEAM.NEW' | translate | uppercase }}</div>
      <img src="assets/images/close.svg" (click)="close()"/>
    </div>

    <form [formGroup]="form">
      <div class="checkbox-field">
        <input type="checkbox" formControlName="external" id="external">
        <label for="external">Check if the user is external</label>
      </div>
      @if (!form.get('external').value) {
        <div class="info">
          <label>{{ 'TEAM.MEMBER' | translate }} ID</label>
          <input type="text" formControlName="teamMemberId">
        </div>
      }
      <div>
        <label>{{ 'TEAM.FIRST_NAME' | translate }}</label>
        <input type="text" formControlName="teamMemberFirstName">
      </div>
      <div>
        <label>{{ 'TEAM.LAST_NAME' | translate }}</label>
        <input type="text" formControlName="teamMemberName">
      </div>
      <div>
        <label>{{ 'TEAM.LANGUAGE' | translate }}</label>
        <input type="text" formControlName="teamMemberLanguage">
      </div>
      <div>
        <label>{{ 'TEAM.PHONE' | translate }}</label>
        <input type="text" formControlName="teamMemberCellularPhone">
      </div>
      <div>
        <label>{{ 'TEAM.EMAIL' | translate }}</label>
        <input type="text" formControlName="teamMemberEmail">
      </div>
      <div>
        <label>{{ 'TEAM.LOCATION' | translate }}</label>
        <select formControlName="peoplelocationcode">
          @for (peopleLocation of peopleLocations; track peopleLocation) {
            <option value="{{ peopleLocation.peoplelocationcode }}">{{ peopleLocation.peoplelocationname }}</option>
          }
        </select>
      </div>
      <div>
        <label>{{ 'TEAM.MOBILE_DEVICE' | translate }}</label>
        <select formControlName="mobileDevicepk">
          <option value="null"></option>
          @for (mobileDevice of mobileDevices; track mobileDevice) {
            <option value="{{ mobileDevice.mobileDevicepk }}">{{ mobileDevice.mobileDeviceModelSupplier }} / {{ mobileDevice.mobileDeviceName }}</option>
          }
        </select>
      </div>
    </form>

    <div class="footer">
      <button (click)="create()" [disabled]="form.invalid">{{ 'CREATE' | translate | uppercase }}</button>
    </div>
  </div>
</div>